export interface ClarityMetadata {
   projectId: string;
   userId: string;
   sessionId: string;
   pageNum: number;
}

const METADATA_TIMEOUT_MS = 500;

declare global {
   interface Window {
      clarity: {
         (event: 'event', action: string): void;
         (event: 'set', key: string, value: string): void;
         (event: 'upgrade', reason: string): void;
         (
            event: 'metadata',
            callback: (data: ClarityMetadata | undefined) => void,
            wait?: boolean,
            recall?: boolean
         ): void;
      };
   }
}

export function trackClarityEvent(action: string) {
   if (typeof window === 'undefined' || window.clarity === undefined) {
      return;
   }

   window.clarity('event', action);
}

export function trackClarityTag(key: string, value: string) {
   if (typeof window === 'undefined' || window.clarity === undefined) {
      return;
   }

   window.clarity('set', key, value);
}

export function upgradeClaritySession(reason: string) {
   if (typeof window === 'undefined' || window.clarity === undefined) {
      return;
   }

   window.clarity('upgrade', reason);
}

export function getClaritySessionId(): Promise<string | null> {
   if (typeof window === 'undefined' || window.clarity === undefined) {
      return Promise.resolve(null);
   }

   return new Promise(resolve => {
      const timer = window.setTimeout(() => resolve(null), METADATA_TIMEOUT_MS);
      try {
         window.clarity(
            'metadata',
            data => {
               window.clearTimeout(timer);
               resolve(data?.sessionId ?? null);
            },
            false,
            true
         );
      } catch {
         window.clearTimeout(timer);
         resolve(null);
      }
   });
}
